import React from "react";
import '../../App.css'
import { Box, Typography, Chip, Popover,} from "@mui/material";
import { useTheme } from "../../ThemeContext";

const DeveloperCell = ({ developers }) => {
  const maxVisible = 4;
  const visibleDevs = developers.slice(0, maxVisible);
  const hiddenDevs = developers.slice(maxVisible);
  const hiddenCount = developers.length - maxVisible;
    const { isDarkMode } = useTheme();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "nowrap",
        gap: 1,
        width: "100%",
        height: "100%", 
        overflow: "hidden",
      }}
    >
      {visibleDevs.map((dev) => (
        <Chip
          key={dev.user_id}
          label={dev.name}
          variant="outlined"
          sx={{
            borderRadius: "16px",
            fontSize: "0.8rem",
            padding: "2px 6px",
            flexShrink: 0,
            // backgroundColor: isDarkMode? "#f4fdfc":" #d9d9d9ff",
            // This color for developer column  in Dark Mode
            backgroundColor: isDarkMode ? "rgba(2, 178, 152, 0.12)" : "#d9d9d9ff",
            borderColor: isDarkMode ? "rgba(2, 178, 152, 0.4)" : "rgba(0,0,0,0.15)",
            color: isDarkMode ? "#a8f0e8" : "inherit",
            "& .MuiChip-label": {
              color: isDarkMode ? "#a8f0e8" : "inherit",
            },
          }}
        />
      ))}

      {hiddenCount > 0 && (
        <>
          <Chip
            label={`+${hiddenCount}`}
            variant="outlined"
            onClick={handleClick}
            sx={{
              borderRadius: "16px",
              fontSize: "0.8rem",
              fontWeight: "bold",
              padding: "2px 6px",
              flexShrink: 0,
              color: "rgba(2, 178, 152, 1)",
              borderColor: "rgba(2, 178, 152, 1)",
              backgroundColor: "transparent",
              cursor: "pointer",
            }}
          />

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Box sx={{ p: 1.5 }}>
              {hiddenDevs.map((dev) => (
                <Typography
                  key={dev.user_id}
                  variant="body2"
                  sx={{ mb: 0.5 }}
                >
                  {dev.name}
                </Typography>
              ))}
            </Box>
          </Popover>
        </>
      )}
    </Box>
  );
};


export default DeveloperCell;
